import { ref } from 'vue'
import { defineStore } from 'pinia'
import { Place } from '~/models/Place'

export const usePlaceStore = defineStore('place', () => {
	const places = ref<Record<string, Place>>({})

	const setPlace = (newPlace: Place) => {
		places.value[newPlace.id] = newPlace
	}

	const getPlace = (placeId: string) => {
		return places.value[placeId]
	}

	return {
		places,
		setPlace,
		getPlace,
	}
})
